/**
 * router/index.ts
 *
 * Automatic routes for `./src/pages/*.vue`
 */

// Composables
import { createRouter, createWebHistory } from 'vue-router/auto';
import { setupLayouts } from 'virtual:generated-layouts';
import { routes } from 'vue-router/auto-routes';

import PageNotFound from '@/pages/page-not-found.vue';

const catchAllRoute = {
  path: '/:pathMatch(.*)*',
  name: 'NotFound',
  component: PageNotFound,
};

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: setupLayouts([...routes, catchAllRoute]),
});

// Workaround for https://github.com/vitejs/vite/issues/11804
router.onError((err, to) => {
  if (err?.message?.includes?.('Failed to fetch dynamically imported module')) {
    if (!localStorage.getItem('vuetify:dynamic-reload')) {
      console.log('Reloading page to fix dynamic import error');
      localStorage.setItem('vuetify:dynamic-reload', 'true');
      location.assign(to.fullPath);
    } else {
      console.error('Dynamic import error, reloading page did not fix it', err);
    }
  } else {
    console.error(err);
  }
});

router.beforeEach((to, from, next) => {
  const auth = JSON.parse(localStorage.getItem('auth') || '{}');
  const isAuthenticated = !!auth.refreshToken;

  if (to.meta.requiresAuth && !isAuthenticated) {
    return next('/login'); // Redirect unauthenticated users
  }

  if (to.meta.role && to.meta.role !== auth.userRole) {
    return next('/unauthorized');
  }
  next(); // Allow navigation
});

router.isReady().then(() => {
  localStorage.removeItem('vuetify:dynamic-reload');
});

export default router;
